<template>
  <div>
    <section class="xlrclh">
      <img
        class="top-img"
        src="../../assets/imgs/jinjiang/2/title-bg.png"
        alt=""
      />
      <div class="technological-process">
        <div class="rhtj mar-t2">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/2/title-1.png"
            alt=""
          />
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （一）博士后科研流动站；
            </div>
          </div>
          <div class="content">
            <div class="font">（二）博士后科研工作站；</div>
          </div>
          <div class="content">
            <div class="font">（三）博士后创新实践基地。</div>
          </div>
        </div>
        <div class="rhtj mar-t2">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/2/title-2.png"
            alt=""
          />
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （一）经人力资源和社会保障部批准可以招收博士后人员的且在锦江区高等院校或科研院所；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （二）经四川省人力资源和社会保障厅审核，人力资源和社会保障部备案后可以招收博士后人员的且在锦江区具备独立法人资格的企事业单位等机构；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （三）经四川省人力资源和社会保障厅批准认定，可联合高校博士后科研流动站共同招收博士后人员的且在锦江区具备独立法人资格的企事业单位等机构。
            </div>
          </div>
        </div>
        <div class="sxcl">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/2/title-3.png"
            alt=""
          />
          <div class="content">
            招收1名及以上博士后人员进站从事科研工作以后，给予新获批流动站、工作站设站单位20万元一次性设站资助，给予新获批基地设站单位10万元一次性设站资助。
          </div>
        </div>
        <div class="rhtj mar-t2">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/2/title-4.png"
            alt=""
          />
          <div class="content">
            <div class="font" style="marginbottom: 0.1rem">
              （一）《锦江区新设立博士后“两站一基地”资助资金申请表》；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （二）主管部门批准设站文件复印件；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （三）新设站单位统一社会信用代码证复印件、年度纳税证明；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （四）带全国博管办编号的《博士后研究人员进站备案证明》、设站单位盖章认定的《博士后进站审核表》，联合招收的还需提供《联合招收协议》；
            </div>
          </div>
          <div class="content">
            <div class="font">
              （五）博士后人员身份证（护照）复印件、学历学位证书（国〈境〉外高校毕业的博士后人员，提供国家教育部留学服务中心出具的学历学位认证书）复印件。
            </div>
          </div>
        </div>
        <div class="sxcl">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/1/title-5.png"
            alt=""
          />
          <div class="content" style="font-weight: 600">
            符合条件的人才向锦江区人社局提出申请。
          </div>
        </div>
        <div class="contact">
          <img
            class="top"
            src="../../assets/imgs/jinjiang/1/title-6.png"
            alt=""
          />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-86511559">028-86511559</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              锦江区人社局
            </div>
          </div>
        </div>
        <!-- <div class="codes">
          <img class="code" src="../assets/imgs/70/code.png" />
          <img class="text" src="../assets/imgs/70/text.png" />
        </div> -->
      </div>
    </section>
    <!-- <call phone="028-83221725"></call> -->
  </div>
</template>

<script>
import call from "../../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.xlrclh {
  background-color: $base-back;

  .top-img {
    width: 100%;
    height: auto;
  }
  .technological-process {
    transform: translateY(-2.1rem);
    .rhtj {
      position: relative;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #d4e0ff;
        margin: -0.35rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        font-size: 0.26rem;
        font-weight: 500;
        color: #4e4e4e;
        text-align: left;
        line-height: 0.44rem;
        .font {
          background-color: #fff;
          border-radius: 0.2rem;
          padding: 0.28rem 0.31rem;
        }
      }
    }

    .sxcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.3rem 0.54rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;
      }
    }
    .sbcl {
      position: relative;
      margin-top: 0.22rem;
      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.95rem auto 0;
        padding: 0.33rem 0.24rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.15rem 0.23rem 0.3rem;
          margin-top: 0.5rem;
          position: relative;
          .title {
            font-size: 0.3rem;
            font-weight: bold;
            color: #333333;
          }
          .item {
            margin-top: 0.3rem;
            box-sizing: border-box;
            position: relative;
            padding-left: 0.42rem;
            display: flex;
            .dot {
              width: 0.39rem;
              height: 0.39rem;
              background-color: #739bfe;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.28rem;
              color: #fff;
              border-radius: 50%;
              position: absolute;
              left: -0.1rem;
              top: 0;
              z-index: 9999;
            }
          }
        }
      }
    }
    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }
        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;
            .line {
              position: absolute;
              width: 0.02rem;
              height: 100%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }
            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }
            .line-top {
              display: flex;
              width: 3.31rem;
              height: 0.49rem;
              background-image: url(../../assets/imgs/jinjiang/1/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.08rem;
              .line-num {
                width: 0.39rem;
                height: 0.39rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.14rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }
            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .code {
        width: 1.94rem;
        height: 1.94rem;
      }
      .text {
        height: 1.72rem;
      }
    }
  }
}
</style>
